import * as React from 'react';
import * as PropTypes from 'prop-types';
import IconWrapper from './IconWrapper';

const IconWidgetQuestion = props =>
  React.createElement(
    IconWrapper,
    props,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      className="block w-full h-full stroke-current fill-transparent"
    >
      <path
        d="M13.7128 15C14.628 13.058 17.0974 11.6667 20.0001 11.6667C23.682 11.6667 26.6668 13.9052 26.6668 16.6667C26.6668 18.9991 24.5374 20.9585 21.6571 21.511C20.7531 21.6844 20.0001 22.4129 20.0001 23.3333M20 28.3333H20.0167M35 20C35 28.2843 28.2843 35 20 35C11.7157 35 5 28.2843 5 20C5 11.7157 11.7157 5 20 5C28.2843 5 35 11.7157 35 20Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>,
  );

IconWidgetQuestion.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};
export default IconWidgetQuestion;
